import {resources} from "../../../../core/models/resource/resources";

export const productCardsResourceParams = resources['product-cards'];
